import React, { useEffect, useState } from "react";
import { PageLayout } from "../../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { GalleryItemContainer } from "../../components";
import { useSelector, useDispatch } from "react-redux";
import { setSessionStorage } from "../../../../sessionAndLocalStorage";
import cameraIcon from '../../../../../public/icons/camera.svg'
import {
  getAppraisalData,
  getLocalImages,
  selectImageUploadData
} from "../../../../store/selectors";
import { removePhoto } from "../../../../store/slices/Appraisal";
import { imageUploadSlice } from "../../../../store/slices/ImageUploads";
import { useSourceSystem } from "../../../../hooks/useSourceSystem";
import { useInitialOffer } from "../../../InitialOffer/useInitialOffer";

export default function PhotoGallery() {
  const { galleryAccordionOpen } = useSelector(selectImageUploadData);
  const [isGalleryOpen, setIsGalleryOpen] = useState(galleryAccordionOpen);
  const images = useSelector(getLocalImages);
  const orderedImages = [...images].sort((a, b) =>
    a.group.toLowerCase().localeCompare(b.group.toLowerCase())
  );

  const { appraisalSessionId, quickValuationPartExchange } =
    useSelector(getAppraisalData);
  const {
    sourceSystem: {
      photoGalleryContent: { stepNumber },
      analyticSearchParam,
      getStepNumber
    }
  } = useSourceSystem();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { handleSubmit } = useInitialOffer();

  const handleRetake = async () => {
    // delete original image
    const imagesToBeDeleted = images.filter(
      (img) => img.flaggedForDeletion && img.extraImage
    );
    imagesToBeDeleted.map((img) => {
      dispatch(imageUploadSlice.actions.deleteImage(img));
      return dispatch(
        removePhoto({
          imageIdentifier: img.imageIdentifier,
          appraisalSessionId
        })
      );
    });
    await dispatch(imageUploadSlice.actions.resetFlagImageForDeletion());
    return navigate("/estimated-offer");
  };

  useEffect(() => {
    dispatch(imageUploadSlice.actions.clearCurrentUploads());
  }, [dispatch]);

  useEffect(() => {
    const imagesWithoutBlob = images.map(({ imageSrc, ...rest }) => rest);
    setSessionStorage("images", imagesWithoutBlob);
  }, [images]);

  dispatch(imageUploadSlice.actions.setReturnToGallery(true));

  const stepNumberProp = getStepNumber(
    quickValuationPartExchange,
    15,
    stepNumber
  );
  const location = useLocation();
  const pathname = location.pathname;
  return (
    <PageLayout>
      <PageLayout.Header title="Your photos" step={stepNumberProp} />
      <PageLayout.Content>
        <div className="ch-text--center ch-mb--4">
          <img
            src={cameraIcon}
            alt="blue camera icon"
            className="ch-mb--3"
          />
          <h4>You've successfully uploaded {images.length} photographs</h4>
          <p>
            You can check you're happy with these images before submitting them
            to your Product Consultant to review.
          </p>
        </div>
        <div className="ch-accordion ch-mb--10">
          <details
            open={galleryAccordionOpen}
            onClick={() => {
              setIsGalleryOpen(!isGalleryOpen);
            }}
          >
            <summary
              className="ch-text--center"
              style={{ paddingLeft: "50px" }}
            >
              View photos
            </summary>
            <div className="ch-accordion__content" style={{ padding: 0 }}>
              {orderedImages.map((image, index) => (
                <div key={index}>
                  <GalleryItemContainer
                    key={image.imageIdentifier}
                    image={image}
                  />
                  <hr className="ch-mt--2" />
                </div>
              ))}
            </div>
          </details>
        </div>
      </PageLayout.Content>

      <PageLayout.Footer>
        {quickValuationPartExchange ? (
          <button
            type="button"
            className="ch-btn ch-btn--success ch-display--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
            onClick={() => handleSubmit(pathname)}
          >
            Save and submit valuation
          </button>
        ) : (
          <button
            type="button"
            className="ch-btn ch-btn--success ch-display--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
            onClick={handleRetake}
          >
            Next: Your estimated valuation
          </button>
        )}
      </PageLayout.Footer>
    </PageLayout>
  );
}
